import { Duplexer } from '@wix/duplexer-js';
import {
  DuplexerEvent,
  DuplexerSubscriber,
} from '@wix/wix-help-widget-common/duplexer';

import { clientSdk } from '../common/ClientSDK';
import { logger } from '../util/logger';

export class WidgetSessionSubscriber extends DuplexerSubscriber {
  constructor(
    protected readonly duplexer: Duplexer,
    protected readonly appDefId: string,
  ) {
    super(duplexer, appDefId, logger);
    this.subscribe(
      DuplexerEvent.WIDGET_SESSION_EXPIRED,
      this.onWidgetSessionExpired,
    );
  }

  unsubscribe() {
    super.unsubscribe();
  }

  private onWidgetSessionExpired = () => {
    // Making sure runtime data is cleared in widget and re-fetched again
    clientSdk.refreshRuntimeData();
    window.location.reload();
  };
}
